<template>
	<span>{{ text }}</span>
</template>

<script>
export default {

	props: {
		textSingular: {
			type: String,
			required: true,
		},
		textPlural: {
			type: String,
			required: true,
		},
		tokens: {
			type: Number,
			required: true,
		},
	},

	computed: {
		text ()
		{
			let text = this.tokens === 1
				? this.textSingular
				: this.textPlural;

			return text.replaceAll('%tokens%', this.tokens.toString());
		}
	}
}
</script>